// ✅ In-memory verified-employee store.
// Survives in-app navigation (e.g. "Raise Another Ticket") but is cleared
// automatically on a full page reload or tab close — so OTP is required again
// after a reload/close, but NOT when raising another ticket in the same session.
let verifiedEmp = null;

export const setVerifiedEmp = (emp) => {
    verifiedEmp = emp;
};

export const getVerifiedEmp = () => verifiedEmp;

export const clearVerifiedEmp = () => {
    verifiedEmp = null;
};
